import React from 'react'
import PropTypes from 'prop-types'
import { Card, CircularProgress, Divider, Grid, Typography } from '@material-ui/core'
import { DescricoesTecnicasVestigio } from './DescricoesTecnicasVestigio'
import { useDescricoesVestigiosExame } from './useDescricoesVestigiosExame'
import useStyles from './DescricoesVestigiosExame.styles'

export const DescricoesVestigiosExame = (props) => {
  const { idExameSolicitado, setAtualizado, idExameRealizado } = props
  const classes = useStyles()

  const { vestigios, processandoVestigios } = useDescricoesVestigiosExame({ idExameSolicitado })

  return (
    <div className={classes.root}>
      {processandoVestigios ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container>
          {vestigios.length > 0 ? (
            vestigios.map((vestigio) => (
              <Grid key={vestigio.id} item xs={12}>
                <Card className={classes.card}>
                  {/* Cabeçalho do Vestígio */}
                  <div className={classes.vestigioHeader}>
                    <div className={classes.vestigioIndicator} />
                    <Typography className={classes.vestigioTitle}>VESTÍGIO {vestigio.identificador}</Typography>
                  </div>

                  {/* Conteúdo de Informações Preliminares */}
                  <Grid container spacing={2} className={classes.infoContainer}>
                    <Grid item md={4} sm={6} xs={12}>
                      <div className={classes.infoItem}>
                        <span className={classes.infoLabel}>Descrição Preliminar</span>
                        <span className={classes.infoValue}>{vestigio.descricao ? vestigio.descricao.toUpperCase() : 'NÃO INFORMADA'}</span>
                      </div>
                    </Grid>
                    <Grid item md={4} sm={6} xs={12}>
                      <div className={classes.infoItem}>
                        <span className={classes.infoLabel}>Lacre</span>
                        <span className={classes.infoValue}>{vestigio.lacre ? vestigio.lacre.toUpperCase() : 'NÃO INFORMADO'}</span>
                      </div>
                    </Grid>
                    <Grid item md={4} sm={6} xs={12}>
                      <div className={classes.infoItem}>
                        <span className={classes.infoLabel}>Tipo Embalagem Secundária</span>
                        <span className={classes.infoValue}>{vestigio.tipoEmbalagem === 'OUTRO' ? (vestigio.outroTipoEmbalagem ? vestigio.outroTipoEmbalagem.toUpperCase() : 'OUTRO') : vestigio.tipoEmbalagem ? vestigio.tipoEmbalagem.toUpperCase() : 'NÃO INFORMADO'}</span>
                      </div>
                    </Grid>
                  </Grid>

                  {/* Seção de Descrições Técnicas */}

                  <div className={classes.vestigioHeader}>
                    <div className={classes.vestigioIndicator} />
                    <Typography className={classes.vestigioTitle}>Descrições Técnicas {vestigio.identificador}</Typography>
                  </div>
                  <div className={classes.technicalSection}>
                    <DescricoesTecnicasVestigio idExameRealizado={idExameRealizado} idVestigio={vestigio.id} setAtualizado={setAtualizado || null} />
                  </div>
                </Card>
              </Grid>
            ))
          ) : (
            <Grid item xs={12} style={{ padding: '24px', textAlign: 'center' }}>
              <Typography color="textSecondary">Nenhum vestígio associado a este exame solicitado.</Typography>
            </Grid>
          )}
        </Grid>
      )}
    </div>
  )
}

DescricoesVestigiosExame.propTypes = {
  idExameSolicitado: PropTypes.number,
  setAtualizado: PropTypes.func,
  idExameRealizado: PropTypes.number,
}
